<section class="search-skeleton-container">
  <div class="topper">
    <div class="sidebar">
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
    </div>

    <div class="items">
      <ion-skeleton-text class="item item_mobile" animated></ion-skeleton-text>
      <ion-skeleton-text class="item item_mobile" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
    </div>
  </div>

  <ion-skeleton-text class="tablet-header" animated></ion-skeleton-text>

  <div class="container">
    <div class="side-container">
      <ion-skeleton-text class="filter-header"></ion-skeleton-text>
      <ion-skeleton-text
        class="filter-header filter-header_tablet"
      ></ion-skeleton-text>
      <ion-skeleton-text
        class="filter-header filter-header_tablet"
      ></ion-skeleton-text>
      <ion-skeleton-text class="filter-action"></ion-skeleton-text>
      <div class="filter-divider"></div>
      <ion-skeleton-text class="filter-item" animated></ion-skeleton-text>
      <div class="filter-divider"></div>
      <ion-skeleton-text class="filter-item" animated></ion-skeleton-text>
    </div>

    <div class="main-container">
      <div class="header-container">
        <ion-skeleton-text class="header" animated></ion-skeleton-text>
        <ion-skeleton-text
          class="action action_mobile"
          animated
        ></ion-skeleton-text>
      </div>
      <div class="actions-container">
        <ion-skeleton-text class="action" animated></ion-skeleton-text>
        <ion-skeleton-text class="action" animated></ion-skeleton-text>
        <ion-skeleton-text class="action last" animated></ion-skeleton-text>
      </div>

      <ion-skeleton-text
        [ngClass]="{ 'item-guest': isGuestUser, 'item ': !isGuestUser }"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        [ngClass]="{ 'item-guest': isGuestUser, 'item ': !isGuestUser }"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        [ngClass]="{ 'item-guest': isGuestUser, 'item ': !isGuestUser }"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text
        [ngClass]="{ 'item-guest': isGuestUser, 'item ': !isGuestUser }"
        animated
      ></ion-skeleton-text>
    </div>
  </div>
</section>
